import { DotsHorizontalIcon } from "@heroicons/react/solid";
import { Markup } from "interweave";
import { React, useContext, useEffect, useState } from "react";
import { Link } from "react-router-dom";
import ShowMoreText from "react-show-more-text";
import noImage from "../../Assets/Images/settings/no-image.png";
import moment from "moment";
import "../../components/CSS/Home/Post.css";
import "../../components/CSS/Sidebar/Left/Enroll.css";
import PostReaction from "./PostReaction";
import { serverInfo } from "../../App";
import axios from "axios";

export default function SingleMeetupPost({ post }) {

  const { imageCdnUrl } = useContext(serverInfo);
  const [isAvaiable,setSlot]=useState(true);

  let todayDate = new Date();
  let endDate = new Date(moment(post?.registration_end_date));

  useEffect(() => {
    axios
      .get(`api/user/check-meetup/slot/${post?.event_id}`)
      .then((res) => {
        if (res.data.status === 200) {
          setSlot(res.data.isAvailable);
        }

      });
  }, []);


  return (
    <div className="container PostWidth align-items-center justify-content-center col-11 Enroll-Auditions">
      <div className="card PostCardBg ">
        <h2 className="accordion-header PostBack">
          <div className="d-flex justify-content-between">
            <div className="accordion-button-fx profile1-accordion-button PostBack  collapsed">
              <img
                src={
                  post.star?.image !== null && post.star?.image !=undefined
                    ? imageCdnUrl + post?.star?.image
                    : noImage
                }
                className="PostImgHome"
                alt="star-profile"
              />
              <span className="mx-2 text-warning text-light">
                <Link
                  to={`/starprofile/${post.user_id}`}
                  className="link-starPorfile"
                >
                  {post.star?.first_name} {post.star?.last_name}
                </Link>
                <br></br>
                <small className="category-size-chat">
                  {moment(post.created_at).format("LT")}
                  {" | "}
                </small>
                <small className="category-size-chat">
                  {moment(post.created_at).format("LL")}
                </small>
              </span>
            </div>
          </div>
        </h2>

        {/* <h5 className="my-2 Enroll-a Enroll-text text-justify ">
          {post?.title}
        </h5> */}

        <ShowMoreText
          lines={3}
          more={<span>See more</span>}
          less={<span>See less</span>}
          className="content-css my-2 Enroll-a Enroll-text py-2"
          anchorClass="my-anchor-css-class"
          expanded={false}
          truncatedEndingComponent={"... "}
        >
          <Markup content={post?.details}></Markup>
        </ShowMoreText>
        <center className="post_new">
            <img
                 src={imageCdnUrl+post?.banner}
                 alt={post?.banner}
            />
          </center>

        <div className="ViewPost">
          <div className=" card  border-0 containerPost">
            <div className="centeredPost ">
              <div className="LeftTextPost col-md-8">
                <div className=" text-light bottom-LeftPost text-start  fw-bold px-4 py-1">
                  Meetup{" "}
                  {post?.post_type === "Online" ? (
                    <>(Online)</>
                  ) : (
                    <>(Offline)</>
                  )}
                </div>
              </div>

              <div className="LeftTextPost col-md-4">
                {endDate.getTime() >= todayDate.getTime() && isAvaiable && (
                    <Link
                      to={`/meetup-event/details/${post?.event_id}`}
                      className="link-starPorfile"
                    >

                      <button className="bottom-rightPost text-dark fw-bold AnimateBtn px-4 py-1">
                        <span className="pTd"> Book Now</span>
                      </button>
                    </Link>
                  )
                  }
              </div>
            </div>
            <div className="centeredPostV "></div>
          </div>

          <PostReaction post={post}></PostReaction>
        </div>
      </div>
    </div>
  );
}
